// Allowed parent origins for iframe embedding
const ALLOWED_PARENT_ORIGINS = [
  window.location.origin,  // Same origin
  'http://localhost:5173', // Admin portal dev
  'http://localhost:3000', // Alternative dev port
  // Add production origins via environment variable
  ...(((import.meta as any).env?.VITE_ALLOWED_PARENT_ORIGINS?.split(',') as string[]) || [])
];

export const authService = {
  getTokenFromUrl(): string | null {
    const params = new URLSearchParams(window.location.search);
    return params.get('token');
  },

  getTokenFromParent(): Promise<string> {
    return new Promise((resolve, reject) => {
      const TIMEOUT_MS = 5000; // 5 second timeout
      let timeoutId: ReturnType<typeof setTimeout>;

      const handler = (event: MessageEvent) => {
        // Validate origin for security
        if (!ALLOWED_PARENT_ORIGINS.includes(event.origin)) {
          console.warn('Rejected token from unauthorized origin:', event.origin);
          return;
        }

        if (event.data.type === 'TOKEN_RESPONSE') {
          clearTimeout(timeoutId);
          window.removeEventListener('message', handler);
          resolve(event.data.token);
        }
      };

      window.addEventListener('message', handler);

      // Send request to parent with specific origin
      const parentOrigin = ALLOWED_PARENT_ORIGINS.find(origin =>
        origin !== window.location.origin
      ) || window.location.origin;

      window.parent.postMessage({ type: 'REQUEST_TOKEN' }, parentOrigin);

      // Set timeout to prevent hanging
      timeoutId = setTimeout(() => {
        window.removeEventListener('message', handler);
        reject(new Error('Token request timeout - parent did not respond'));
      }, TIMEOUT_MS);
    });
  },

  async getToken(): Promise<string | null> {
    const urlToken = this.getTokenFromUrl();
    if (urlToken) return urlToken;

    if (window.parent !== window) {
      try {
        return await this.getTokenFromParent();
      } catch (error) {
        console.error('Failed to get token from parent:', error);
        return null;
      }
    }

    return null;
  }
};
